import { render, staticRenderFns } from "./AddonProducts.vue?vue&type=template&id=4a48c6cc"
import script from "./AddonProducts.vue?vue&type=script&lang=js"
export * from "./AddonProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports